"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const LoginModal_1 = __importDefault(require("./LoginModal"));
const react_redux_1 = require("react-redux");
const LoginModalWrapper = () => {
    const { isLoginModalOpen } = (0, react_redux_1.useSelector)((state) => state.loginModal);
    return isLoginModalOpen ? react_1.default.createElement(LoginModal_1.default, null) : null;
};
exports.default = LoginModalWrapper;
